import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_monitor_indoor_air_quality_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_monitor_indoor_air_quality_in_line_w_legal_reqs',
  name: 'Does the facility monitor indoor air quality in line with legal requirements?',
  description:
    "Indoor Air Quality' generally refers to comfort parameters such as temperature, humidity, and carbon dioxide as well as general concentrations of particulates or chemicals (VOC) in the general workspace. \r\r\nThe intent is to determine if the facility ensures workers are working in an environment with acceptable general indoor air quality.  This is not meant to address exposure assessment to specific hazardous substances whereas it is required to evaluate if exposures exceed a defined exposure limit. \r\r\n\r\r\nConsult applicable legal requirements.\r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-gen-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13400,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
